import React, {useContext} from "react";
import {UserContext} from "../../state/UserContext";
import {Navigate} from "react-router-dom";

const Protected = (props) => {
    const userContext = useContext(UserContext);

    return userContext.loggedUser ? props.children : <Navigate to="/login" replace/>;
};

export default Protected;
